import type { ICompanySegment } from "../../../helpers";

import { CompaniesDropdown, DivisionsDropdown, MarketsDropdown, RegionsDropdown } from ".";
import { useCompanySegmentFilterCascaded } from "../../../helpers";
import { useSyncedSegment } from "../useSyncedSegment";
import { ManagementAreaDropdown } from "./managementAreaDropdown";

export function CompanySegmentFilters(props: Props) {
	const { value, onChange, onUnfocused } = props;
	const [segmentFilters, segmentChanged] = useSyncedSegment(
		value,
		onChange,
		COMPANY_SEGMENT_KEYS,
		emptyCompanySegmentFilters,
	);
	const availableSegments = useCompanySegmentFilterCascaded(segmentFilters);

	return (
		<>
			{props.includeCompany && (
				<CompaniesDropdown
					options={availableSegments.companies}
					loaded={availableSegments.companiesLoaded}
					value={segmentFilters.companyIds ?? []}
					changeHandler={segmentChanged}
					onUnfocused={onUnfocused}
					maxSelectedDisplay={3}
				/>
			)}
			<DivisionsDropdown
				options={availableSegments.divisions}
				loaded={availableSegments.divisionsLoaded}
				value={segmentFilters.companyDivisionIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<RegionsDropdown
				options={availableSegments.regions}
				loaded={availableSegments.regionsLoaded}
				value={segmentFilters.companyRegionIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<MarketsDropdown
				options={availableSegments.markets}
				loaded={availableSegments.marketsLoaded}
				value={segmentFilters.companyMarketIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
			<ManagementAreaDropdown
				options={availableSegments.managementAreas}
				loaded={availableSegments.managementAreasLoaded}
				value={segmentFilters.companyManagementAreaIds ?? []}
				changeHandler={segmentChanged}
				onUnfocused={onUnfocused}
				maxSelectedDisplay={3}
			/>
		</>
	);
}

export const emptyCompanySegmentFilters: ICompanySegment = {
	companyIds: [],
	companyDivisionIds: [],
	companyRegionIds: [],
	companyMarketIds: [],
	companyManagementAreaIds: [],
};

const COMPANY_SEGMENT_KEYS = [
	"companyId",
	"companyDivisionId",
	"companyRegionId",
	"companyMarketId",
	"companyManagementAreaId",
	"companyIds",
	"companyDivisionIds",
	"companyRegionIds",
	"companyMarketIds",
	"companyManagementAreaIds",
] as const satisfies readonly (keyof ICompanySegment)[];

interface Props {
	onChange: (filters: ICompanySegment) => void;
	value?: ICompanySegment;
	onUnfocused?: (event?: React.FocusEvent<any>) => void;
	includeCompany?: boolean;
}
